module.exports = __webpack_public_path__ + "img/logo.d41d8cd9.svg";